import { TextField, createMuiTheme } from '@material-ui/core';
import Button, { ButtonProps } from '@material-ui/core/Button';
import styled, { css } from 'styled-components';
import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form';
import { Colors } from '../../Foundation/Colors';
import { Fonts } from '../../Foundation/Fonts';
import { IconButton } from '../../Atoms/Navigations/IconButton';

export const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: Colors.error,
        '&$error': {
          color: Colors.error,
        },
      },
    },
  },
});

export const SubHeading = styled.div`
  ${Fonts.capsHeading}
  padding-top: 48px;
  padding-bottom: 24px;
`;

export const StyledTextField = styled(TextField)<{ isValid: boolean }>`
  & .MuiInputBase-root {
    max-height: 48px;
  }

  & .MuiInputLabel-outlined {
    transform: translate(14px, 16px) scale(1);
  }

  & label.Mui-focused {
    color: ${Colors.accent};
  }

  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: ${Colors.accent};
    }
  }

  & .MuiFormControl-root {
    margin-bottom: 24px;
  }

  input[type='search']::-webkit-search-cancel-button {
    -webkit-appearance: none;
    height: 20px;
    width: 20px;
    border-radius: 50%;

    ${({ isValid }) =>
      isValid
        ? // TickCircleOutline.svg
          css`
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M17.0721 3.37019L16.8188 3.80129L16.8231 3.80375L17.0721 3.37019ZM20.6298 6.92788L20.1962 7.17696L20.1987 7.1812L20.6298 6.92788ZM20.6298 17.0721L20.1987 16.8188L20.1963 16.8231L20.6298 17.0721ZM17.0721 20.6298L16.823 20.1962L16.8188 20.1987L17.0721 20.6298ZM6.92788 20.6298L7.1812 20.1987L7.18039 20.1983L6.92788 20.6298ZM3.37019 17.0481L3.80377 16.799L3.80127 16.7948L3.37019 17.0481ZM3.37019 6.95192L3.80127 7.20524L3.80175 7.20443L3.37019 6.95192ZM6.95192 3.37019L7.20443 3.80175L7.20524 3.80127L6.95192 3.37019ZM12 2.5C13.7391 2.5 15.3422 2.93356 16.8188 3.80127L17.3254 2.93911C15.6931 1.97989 13.9148 1.5 12 1.5V2.5ZM16.8231 3.80375C18.2527 4.62505 19.375 5.74727 20.1963 7.17695L21.0634 6.67882C20.1539 5.09566 18.9043 3.84611 17.3212 2.93664L16.8231 3.80375ZM20.1987 7.1812C21.0664 8.65784 21.5 10.2609 21.5 12H22.5C22.5 10.0852 22.0201 8.30692 21.0609 6.67457L20.1987 7.1812ZM21.5 12C21.5 13.7391 21.0664 15.3422 20.1987 16.8188L21.0609 17.3254C22.0201 15.6931 22.5 13.9148 22.5 12H21.5ZM20.1963 16.8231C19.375 18.2527 18.2527 19.375 16.8231 20.1963L17.3212 21.0634C18.9043 20.1539 20.1539 18.9043 21.0634 17.3212L20.1963 16.8231ZM16.8188 20.1987C15.3422 21.0664 13.7391 21.5 12 21.5V22.5C13.9148 22.5 15.6931 22.0201 17.3254 21.0609L16.8188 20.1987ZM12 21.5C10.2609 21.5 8.65784 21.0664 7.1812 20.1987L6.67457 21.0609C8.30692 22.0201 10.0852 22.5 12 22.5V21.5ZM7.18039 20.1983C5.74883 19.3606 4.62551 18.2295 3.80375 16.799L2.93664 17.2971C3.84565 18.8795 5.0941 20.1362 6.67538 21.0614L7.18039 20.1983ZM3.80127 16.7948C2.93314 15.3174 2.5 13.7222 2.5 12H1.5C1.5 13.8996 1.98031 15.6698 2.93911 17.3014L3.80127 16.7948ZM2.5 12C2.5 10.2778 2.93314 8.68259 3.80127 7.20524L2.93911 6.69861C1.98031 8.33025 1.5 10.1004 1.5 12H2.5ZM3.80175 7.20443C4.63983 5.77207 5.77207 4.63983 7.20443 3.80175L6.69942 2.93864C5.11894 3.86338 3.86338 5.11894 2.93864 6.69942L3.80175 7.20443ZM7.20524 3.80127C8.68259 2.93314 10.2778 2.5 12 2.5V1.5C10.1004 1.5 8.33025 1.98031 6.69861 2.93911L7.20524 3.80127Z' fill='%23007A76 '/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.98084 17.0241L18.9953 8.00968L17.577 6.54333L9.98084 14.1635L6.42315 10.5818L5.00488 12.0001L9.98084 17.0241Z' fill='%23007A76 '/%3E%3C/svg%3E");
            opacity: 100%;
          `
        : // CloseCircleOutline.svg
          css`
            background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 24 24' fill='%23000000' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 22L11.9992 22.75H12V22ZM2 12H1.25L1.25 12.0008L2 12ZM12 22.75C17.9371 22.75 22.75 17.9371 22.75 12H21.25C21.25 17.1086 17.1086 21.25 12 21.25V22.75ZM22.75 12C22.75 6.06294 17.9371 1.25 12 1.25V2.75C17.1086 2.75 21.25 6.89137 21.25 12H22.75ZM12 1.25C6.06294 1.25 1.25 6.06294 1.25 12H2.75C2.75 6.89137 6.89137 2.75 12 2.75V1.25ZM1.25 12.0008C1.2567 17.9347 6.06534 22.7433 11.9992 22.75L12.0008 21.25C6.89413 21.2442 2.75576 17.1059 2.75 11.9992L1.25 12.0008Z' /%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.8705 15.4115C16.9396 15.4809 16.9741 15.5677 16.9741 15.6719C16.9741 15.776 16.9396 15.8628 16.8705 15.9323L15.886 16.8958C15.8169 16.9653 15.7392 17 15.6529 17C15.5492 17 15.4629 16.9653 15.3938 16.8958L12 13.4844L8.60622 16.8958C8.53713 16.9653 8.45941 17 8.37306 17C8.26943 17 8.18308 16.9653 8.11399 16.8958L7.12953 15.9323C7.06045 15.8628 7.02591 15.776 7.02591 15.6719C7.02591 15.5677 7.06045 15.4809 7.12953 15.4115L10.5492 12L7.12953 8.61458C6.95682 8.44097 6.95682 8.26736 7.12953 8.09375L8.08808 7.10417C8.19171 7.03472 8.27807 7 8.34715 7C8.45078 7 8.53713 7.03472 8.60622 7.10417L12 10.4896L15.3938 7.10417C15.4974 7.03472 15.5838 7 15.6529 7C15.7565 7 15.8428 7.03472 15.9119 7.10417L16.8705 8.09375C17.0432 8.26736 17.0432 8.43229 16.8705 8.58854L13.4508 11.974L16.8705 15.4115Z' /%3E%3C/svg%3E");
            opacity: 30%;
          `};
  }

  input[type='search']::-webkit-search-cancel-button:hover {
    // CloseCircleOutline.svg
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 24 24' fill='%23000000' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 22L11.9992 22.75H12V22ZM2 12H1.25L1.25 12.0008L2 12ZM12 22.75C17.9371 22.75 22.75 17.9371 22.75 12H21.25C21.25 17.1086 17.1086 21.25 12 21.25V22.75ZM22.75 12C22.75 6.06294 17.9371 1.25 12 1.25V2.75C17.1086 2.75 21.25 6.89137 21.25 12H22.75ZM12 1.25C6.06294 1.25 1.25 6.06294 1.25 12H2.75C2.75 6.89137 6.89137 2.75 12 2.75V1.25ZM1.25 12.0008C1.2567 17.9347 6.06534 22.7433 11.9992 22.75L12.0008 21.25C6.89413 21.2442 2.75576 17.1059 2.75 11.9992L1.25 12.0008Z' /%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.8705 15.4115C16.9396 15.4809 16.9741 15.5677 16.9741 15.6719C16.9741 15.776 16.9396 15.8628 16.8705 15.9323L15.886 16.8958C15.8169 16.9653 15.7392 17 15.6529 17C15.5492 17 15.4629 16.9653 15.3938 16.8958L12 13.4844L8.60622 16.8958C8.53713 16.9653 8.45941 17 8.37306 17C8.26943 17 8.18308 16.9653 8.11399 16.8958L7.12953 15.9323C7.06045 15.8628 7.02591 15.776 7.02591 15.6719C7.02591 15.5677 7.06045 15.4809 7.12953 15.4115L10.5492 12L7.12953 8.61458C6.95682 8.44097 6.95682 8.26736 7.12953 8.09375L8.08808 7.10417C8.19171 7.03472 8.27807 7 8.34715 7C8.45078 7 8.53713 7.03472 8.60622 7.10417L12 10.4896L15.3938 7.10417C15.4974 7.03472 15.5838 7 15.6529 7C15.7565 7 15.8428 7.03472 15.9119 7.10417L16.8705 8.09375C17.0432 8.26736 17.0432 8.43229 16.8705 8.58854L13.4508 11.974L16.8705 15.4115Z' /%3E%3C/svg%3E");
    opacity: 100%;
  }
`;

export const StyledButton = styled(Button)<{ variant: ButtonProps['variant'] }>`
  && {
    text-transform: none;
    border-radius: 22px;
    ${({ variant }) =>
      variant === 'contained'
        ? css`
            background-color: ${Colors.accent};
            color: ${Colors.white};
          `
        : css`
            border-color: ${Colors.accent};
            color: ${Colors.accent};
            &:hover {
              background-color: ${Colors.accent_1};
            }
          `}
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormSection = styled.section`
  display: flex;
  flex-direction: column;
  row-gap: 40px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 48px;
`;

export const StyledPhoneInput = styled(PhoneInputWithCountry)`
  display: flex;
  gap: 8px;
  max-height: 48px;
`;

export const StyledTextFieldStyleProps = {
  variant: 'outlined',
  inputProps: {
    style: { color: Colors.black },
  },
};

export const StyledIconButton = styled(IconButton)`
  svg {
    fill: ${Colors.black};
  }
`;
